<template>
  <div id="popupSelector">
    <div class="closingLayer">
      <edit-profile v-if="popUpVar === 1"/>
      <remove-card v-if="popUpVar === 2"/>
      <add-card-form v-if="popUpVar === 3"/>
      <edit-pay-graphic v-if="popUpVar === 4"/>
      <accept-new-pay-graph v-if="popUpVar === 5"/>
      <approve-new-graphic v-if="popUpVar === 6"/>
      <pay-ahead v-if="popUpVar === 7"/>
      <success-popup v-if="popUpVar === 8"/>
      <failed-popup v-if="popUpVar === 9"/>
      <requisites-popup v-if="popUpVar === 10"/>
    </div>
  </div>
</template>

<script>
import EditProfile from '@/components/popUp/edit-profile';
import RemoveCard from '@/components/popUp/remove-card';
import { mapState } from 'vuex';
import AddCardForm from '@/components/popUp/add-card-form';
import EditPayGraphic from '@/components/popUp/edit-pay-graphic';
import AcceptNewPayGraph from '@/components/popUp/accept-new-pay-graph';
import ApproveNewGraphic from '@/components/popUp/approved-new-graphic';
import PayAhead from '@/components/popUp/pay-ahead';
import SuccessPopup from '@/components/popUp/success-popup'
import FailedPopup from '@/components/popUp/failed-popup'
import RequisitesPopup from '@/components/popUp/requisites-popup'
export default {
  name: 'popup-selector',
  components: { RequisitesPopup, FailedPopup, SuccessPopup, ApproveNewGraphic, AcceptNewPayGraph, EditPayGraphic, AddCardForm, RemoveCard, EditProfile, PayAhead },
  methods: {
    test () {
      alert('asdf');
    }
  },
  computed: {
    ...mapState({
      popUpVar: state => state.popUpVar
    })
  }
};
</script>

<style scoped>
#popupSelector {}
#popupSelector>.closingLayer { background-color: rgba(0, 0, 0, 0.49); width: 100%; height: 100%; position: fixed; top: 0; left: 0; display: flex; align-items: center;justify-content: center; z-index: 11}
#popupSelector>.closingLayer>div { z-index: 20 }
</style>
